export const BannerLanguages: { [locale: string]: string } = {
	"en-us": "EN",
	"es-es": "ES",
	"es-mx": "ES",
	"ca-es": "CA"
}
